export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_EU-ko-KR.9aff67ff.xlsx";